module.exports = __webpack_public_path__ + "img/logozsybig.135c349a.png";